import { DESKTOP_HARDCODE_LINKS } from 'constants/links';
import { DOWNLOAD_APP_EVENT_LABELS } from 'constants/analytics';

import Logo from 'components/Logo';

import * as S from './styled';

import StoreButton from '../StoreButton';

const DownloadWithTabletLinks = ({
    handleLinkDownloadApp,
}: {
    handleLinkDownloadApp: (eventLabel: string, isDeeplinkBtn?: boolean) => void;
}) => {
    return (
        <S.TabletWrapper>
            <S.Footer
                $borderRadius={16}
                $paddingBottom={24}
                $paddingTop={24}
                $paddingX={24}
                $backgroundColor="surface-secondary"
                $mb={56}
            >
                <Logo />
                <S.FlexWrapper>
                    <div
                        onClick={() => handleLinkDownloadApp(DOWNLOAD_APP_EVENT_LABELS.ios_bot)}
                        data-locator="appleStoreLink"
                    >
                        <StoreButton customLink={DESKTOP_HARDCODE_LINKS.APPLE} type="apple" />
                    </div>
                    <div
                        onClick={() => handleLinkDownloadApp(DOWNLOAD_APP_EVENT_LABELS.android_bot)}
                        data-locator="googleStoreLink"
                    >
                        <StoreButton type="google" customLink={DESKTOP_HARDCODE_LINKS.GOOGLE} />
                    </div>
                </S.FlexWrapper>
            </S.Footer>
        </S.TabletWrapper>
    );
};

export default DownloadWithTabletLinks;
